import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  rx: "8",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.99927 10.4926C8.49685 10.4926 8.90049 10.8954 8.90063 11.3929C8.90063 11.8906 8.49694 12.2943 7.99927 12.2943C7.50182 12.294 7.09888 11.8905 7.09888 11.3929C7.09902 10.8956 7.5019 10.4928 7.99927 10.4926ZM7.99927 3.70544C8.36319 3.70544 8.65845 4.0007 8.65845 4.36462V8.81287C8.65824 9.17661 8.36306 9.47107 7.99927 9.47107C7.63566 9.47085 7.34127 9.17648 7.34106 8.81287V4.36462C7.34106 4.00083 7.63553 3.70566 7.99927 3.70544Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }